
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
/* eslint-disable prettier/prettier */
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { ConversionSection } from "@/sections/ConversionSection";

const MuralToMiro = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/MuralToMiro"
        ogImage="/images/mural2miro-og-image.jpg"
      />

      <MagicianSection
        title={t("page/MuralToMiro:title")}
        subtitle={t("page/MuralToMiro:subtitle")}
        magicianLogoFile="mural"
        showStartsAt={false}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/MuralToMiro:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/MuralToMiro:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/mural-to-miro-example.png",
          alt: "Mural to Miro Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/MuralToMiro:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/mural-to-miro-converted-file-elements.png",
          alt: t("page/MuralToMiro:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/MuralToMiro:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "NOTES",
            title: t(
              "page/MuralToMiro:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/MuralToMiro:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "ARROW-BLACK",
            title: t(
              "page/MuralToMiro:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/MuralToMiro:section/shareDesign.elements.folderStructureText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("page/MuralToMiro:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("page/MuralToMiro:section/conversion.badges.supportsAll"),
          },
          {
            iconType: "NOTES",
            text: t("page/MuralToMiro:section/conversion.badges.stickyNotes"),
          },
          {
            iconType: "ARROW-BLACK",
            text: t("page/MuralToMiro:section/conversion.badges.connectors"),
          },
        ]}
        elements={{
          from: {
            iconType: "MURAL",
            image: "/images/miro-mural-preview.jpg",
            title: "Mural Import Demo Preview",
          },
          to: {
            iconType: "MIRO",
            image: "/images/miro-to-mural-preview.png",
            title: "Miro Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.muralToMiroPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default MuralToMiro;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/mural-to-miro',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  